import React from 'react';
import { PhoneIcon } from 'lucide-react';
import type { MembershipCopy } from '../../data/membership';
import { business } from '../../data/business';
import { selectServiceAndScroll } from '../../utils/booking';
interface MembershipJoinProps {
  copy: MembershipCopy;
}
export function MembershipJoin({
  copy
}: MembershipJoinProps) {
  const featuredPlan = copy.plans.find(plan => plan.featured) ?? copy.plans[0];
  return <div className="mt-20 overflow-hidden rounded-2xl bg-navy" data-id="element-284" data-mp="2xb8isy5v1ur6">
      <div className="grid lg:grid-cols-[1.1fr_1fr]" data-id="element-285" data-mp="32alfeamjag6y">
        <div className="p-8 sm:p-10" data-id="element-286" data-mp="329a2nlb41y3p">
          <h3 className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-287" data-mp="37aha1j9ccv9u">
            {copy.cta.title}
          </h3>
          <p className="mt-2 text-base font-medium text-brand-cyan" data-id="element-288" data-mp="3c89cv8biy1st">{copy.cta.subtitle}</p>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-white/70" data-id="element-289" data-mp="1cwyhyoy2y4vx">
            {copy.cta.description}
          </p>
          <p className="mt-2 max-w-md text-sm leading-relaxed text-white/70" data-id="element-290" data-mp="1hvt708mn4poh">
            {copy.cta.pricingNote}
          </p>
          <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-291" data-mp="2rs1z58s0kgla">
            <button type="button" onClick={() => selectServiceAndScroll(featuredPlan.optionLabel)} className="inline-flex min-h-[48px] items-center justify-center rounded-lg bg-brand-orange px-7 text-base font-semibold text-white transition-colors duration-150 hover:bg-brand-orangeDark" data-id="element-292" data-mp="2my7iyfbmajqy">
              {copy.cta.button}
            </button>
            <a href={business.phoneHref} className="inline-flex items-center gap-2 text-sm text-white/75 transition-colors duration-150 hover:text-white" data-id="element-293" data-mp="35qt86gs0rc2k">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-294" data-mp="2wp24fhh1hfbc" />
              {copy.cta.questions}{' '}
              <span className="font-semibold text-white" data-id="element-295" data-mp="1pd30l01oy5o6">{business.phoneDisplay}</span>
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 bg-navy-800 p-8 sm:p-10 lg:border-l lg:border-t-0" data-id="element-296" data-mp="1mrlko59ha15f">
          <p className="text-sm font-semibold text-white" data-id="element-297" data-mp="1rq59cdfghr1h">{copy.stepsTitle}</p>
          <ol className="mt-5 space-y-5" data-id="element-298" data-mp="1ro2lo01s09zx">
            {copy.steps.map((step, index) => <li key={step.title} className="flex gap-4" data-id="element-299" data-mp="1cv8rr9lrbrbq" data-mpi={index}>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-brand-orange font-display text-sm font-bold text-brand-orange" data-id="element-300" data-mp="1hr7p3mp2cjoa">
                  {index + 1}
                </span>
                <span data-id="element-301" data-mp="18svpiv67ybjp">
                  <span className="block text-sm font-semibold text-white" data-id="element-302" data-mp="u2oev1mgdwtk">{step.title}</span>
                  <span className="mt-0.5 block text-sm text-white/65" data-id="element-303" data-mp="u0ttjm79s2oy">{step.text}</span>
                </span>
              </li>)}
          </ol>
        </div>
      </div>
    </div>;
}